import type { RequestOptions } from '@mts-fe/types';
import type { AxiosRequestConfig } from 'axios';
import { downloadByData, message, RequestMethod } from '@mts-fe/utils';
import { t } from '@mts/hooks/web/useI18n';
import { defHttp } from '@mts/utils/http/axios';
import { createApi } from '@/api';

/**
 * Download file according to api
 * @deprecated 推荐直接在平台配置 基础导出 + { "exportBlob": true }，或使用手写方法 runExportTask()
 */
export function downloadFile(
  apiPath: string,
  params?: Recordable,
  config: AxiosRequestConfig = {},
  options?: RequestOptions,
) {
  return createApi(
    apiPath,
    config.method as RequestMethod,
    { responseType: 'blob', timeout: 6e5, ...config },
    { isReturnNativeResponse: true, ...options },
  )({ ...params }).then(async (res) => {
    if (res.status === 200) {
      try {
        const jsonText = await res.data.text();
        const { error, message: msg } = JSON.parse(jsonText);
        if (error) {
          message.error(msg);
          return;
        }
      } catch (error) {
        console.assert(error);
      }

      const disposition = res.headers.get('content-disposition') as string;
      const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
      const filename =
        matches != null && matches[1] ? decodeURIComponent(matches[1].replace(/['"]/g, '')) : '';
      downloadByData(res.data, filename);
    } else {
      message.error(res.message || t('sys.api.apiRequestFailed'));
    }
  });
}

/**
 * Upload file
 * @param {*} file
 * @param {*} bucketName
 */
export async function uploadFile(
  file: File,
  bucketName = 'pic-file-bucket',
): Promise<{ uploadKey: string; uploadType: number } | false> {
  try {
    const res = await defHttp.uploadFile(
      { url: '/ims-system/system/file/upload' },
      { file, data: { bucketName } },
    );
    return res;
  } catch (error) {
    return false;
  }
}
